__webpack_require__.p = "/Low-Poly-Effect-Parallel-Renderer/";